import { SpawnType } from "@1games-ru/region-shared/dist/enums/selectSpawn/type";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";
import useAppSelector from "@/core/helpers/useAppSelector";
import { activeKeySelector } from "@/domains/activeKey/slice";
import "@/domains/spawn/slice";
import useHandlers from "@/domains/spawn/hooks/useHandlers";
import SpawnNavigateButton from "@/domains/spawn/components/SpawnNavigateButton";
import KeyCode from "@/assets/constants/key-code";

type Props = {
  className?: string;
};

export default function SpawnNavigationContainer({ className }: Props) {
  const { t } = useTranslation("spawn");
  const activeKey = useAppSelector(activeKeySelector);
  const {
    setActiveSpawnHandler,
    confirmSpawnHandler,
    nextHoverSpawnHandler,
    prevHoverSpawnHandler,
  } = useHandlers();

  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <div className="flex items-center gap-2.5">
        <SpawnNavigateButton
          onClick={() => confirmSpawnHandler()}
          label="Enter"
          isActive={KeyCode.ENTER === activeKey}
        />
        <div className="text-16 text-white font-medium">{t("spawn.enter")}</div>
      </div>
      <div className="flex items-center gap-2.5">
        <SpawnNavigateButton
          onClick={() => setActiveSpawnHandler(SpawnType.Undefined)}
          label="ESC"
          isActive={KeyCode.ESCAPE === activeKey}
        />
        <div className="text-16 text-white font-medium">{t("spawn.esc")}</div>
      </div>
      <div className="flex items-center gap-2.5">
        <SpawnNavigateButton
          onClick={() => prevHoverSpawnHandler()}
          label="&#9668;"
          className="w-[2.625rem] font-arial"
          isActive={KeyCode.LEFT_ARROW === activeKey}
        />
        <SpawnNavigateButton
          onClick={() => nextHoverSpawnHandler()}
          label="&#9658;"
          className="w-[2.625rem] font-arial"
          isActive={KeyCode.RIGHT_ARROW === activeKey}
        />
        <div className="text-16 text-white font-medium">{t("spawn.cardNavigation")}</div>
      </div>
    </div>
  );
}
